module.exports = __webpack_public_path__ + "img/4e43cae26906482c574c43eb127b9ef9.png";